import { useId } from 'react';

import {
  type HTMLChakraProps,
  type ThemingProps,
  chakra,
  useTheme,
} from '@chakra-ui/react';

export const Illustration404 = ({
  colorScheme = 'brand',
  ...rest
}: HTMLChakraProps<'svg'> & { colorScheme?: ThemingProps['colorScheme'] }) => {
  const clipPathId01 = useId();
  const clipPathId02 = useId();
  const theme = useTheme();
  return (
    <chakra.svg
      width={300}
      maxW="full"
      viewBox="0 0 200 200"
      fill="none"
      {...rest}
    >
      <g clipPath={`url(#${clipPathId01})`}>
        <g clipPath={`url(#${clipPathId02})`}>
          <path
            d="M79.901 193.874s34.503 7.676 64.246-15.088c29.742-22.764 40.962-62.004 50.891-93.55 9.93-31.546-2.248-60.857-28.796-71.61s-40.525 11.699-74.975 17.01c-34.45 5.312-44.43 1.477-70.445 24.712C-5.19 78.584-4.06 125.682 23.271 157.2c27.33 31.517 56.63 36.674 56.63 36.674z"
            fill="currentColor"
            opacity={0.05}
          />
          <path
            d="M93.832 188.808c-12.24 0-23.48-2.095-33.41-6.22-17.016-7.077-31.589-21.018-38.979-37.312a60.742 60.742 0 01-1.476-3.545c-4.96-12.936-6.237-27.814-3.688-43.032 3.73-22.293 15.047-41.64 31.036-53.072C59.611 36.837 75.037 32 90.767 32c4.793 0 9.576.45 14.285 1.344 13.508 2.574 24.926 9.468 32.156 19.407a234.013 234.013 0 013.701 5.35c2.633 3.897 5.118 7.582 8.349 11.024 5.168 5.512 11.024 10.388 15.556 14.022 4.533 3.634 9.193 7.747 13.305 13.746a57.158 57.158 0 017.671 16.888c8.212 29.676-14.12 55.065-40.425 64.817-12.537 4.664-31.66 10.197-51.528 10.197l-.005.013z"
            fill={theme.colors[colorScheme][900]}
          />
          <path
            d="M132.21 90.97a1.939 1.939 0 10.09 3.877 1.939 1.939 0 00-.09-3.877zM113.343 134a1.933 1.933 0 00-1.759 1.243 1.94 1.94 0 00.474 2.101 1.938 1.938 0 003.274-1.455 1.944 1.944 0 00-.602-1.358 1.93 1.93 0 00-1.387-.531zM128.196 111.753a.971.971 0 10.044 1.942.971.971 0 00-.044-1.942zM107.047 137.72c-.181 1.645-.357 1.831-1.989 2.093 1.641.181 1.808.357 2.088 1.989.186-1.641.362-1.808 1.994-2.089-1.646-.185-1.831-.348-2.093-1.993zM74.892 115.85c7.31-5.17 9.044-15.285 3.874-22.594-5.17-7.309-15.285-9.043-22.594-3.874-7.309 5.17-9.043 15.286-3.874 22.594 5.17 7.309 15.286 9.043 22.594 3.874z"
            fill={theme.colors.white}
          />
          <path
            d="M81.736 102.988l-17.22-11.267 16.415 5.835a15.32 15.32 0 00-.346-.955l-20.506-9.25a16 16 0 00-3.42 1.697l4.678 3.1-6.281-1.909 6.494 4.876-9.436-1.59c-.13.194-.255.388-.378.586l20.185 8.858-14.331-3.305 6.49 4.263-7.25-1.327 21.74 9.642a16.106 16.106 0 002.753-5.96l-5.165-3.589 5.413 2.245c.093-.646.148-1.298.165-1.95zM76.26 114.764l-17.573-8.111 8.715 5.608-17.143-4.214a16.197 16.197 0 0019.953 10.086l-6.394-1.997 8.96.981a16.092 16.092 0 003.481-2.353zM64.849 86.433l9.876 4.606-2.611-2.28 2.825.67a16.146 16.146 0 00-10.09-2.996zM55.045 104.861l-5.684-3.25a16.345 16.345 0 00.476 5.037l5.208-1.787z"
            fill={theme.colors[colorScheme][300]}
          />
          <path
            d="M74.892 115.85c7.31-5.17 9.044-15.285 3.874-22.594-5.17-7.309-15.285-9.043-22.594-3.874-7.309 5.17-9.043 15.286-3.874 22.594 5.17 7.309 15.286 9.043 22.594 3.874z"
            stroke={theme.colors[colorScheme][900]}
            strokeWidth={0.672}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M83.05 82.88c-2.139-1.87-7.045-.044-12.73 4.247.557.175 1.103.378 1.638.61 4.243-3.219 7.661-4.646 9.04-3.444 2.445 2.137-2.453 11.753-10.945 21.473-8.492 9.721-17.358 15.876-19.804 13.738-1.26-1.101-.566-4.19 1.56-8.255-.308-.492-.591-1-.846-1.521-2.972 5.664-3.845 10.244-1.846 11.99 3.388 2.96 13.726-3.339 23.095-14.065 9.369-10.726 14.227-21.816 10.837-24.773z"
            fill={theme.colors[colorScheme][300]}
            stroke={theme.colors[colorScheme][900]}
            strokeWidth={0.672}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M172.901 119.222c-2.116-1.528-4.398.877-2.771 2.911 2.115 1.528 4.402-.877 2.771-2.911zM153.659 127.846a1.004 1.004 0 10-1.381 1.457 1.004 1.004 0 001.381-1.457zM175.274 106.413a.968.968 0 00-.93 1.182.967.967 0 00.782.747.973.973 0 00.837-1.661.97.97 0 00-.689-.268z"
            fill={theme.colors.white}
          />
          <path
            d="M91.135 153.221c.424-5.348-3.567-10.028-8.914-10.452-5.348-.425-10.028 3.566-10.452 8.914-.425 5.348 3.566 10.027 8.914 10.452 5.348.424 10.027-3.567 10.452-8.914z"
            fill={theme.colors.white}
            stroke={theme.colors.white}
            strokeWidth={1.048}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M86.215 147.118l4.872 6.491a9.635 9.635 0 00-.312-3.842l-4.56-2.649zM76.257 144.257l11.585 15.508a9.632 9.632 0 002.215-2.834l-9.741-14.116a9.753 9.753 0 00-4.059 1.442zM81.351 162.151l-5.035-6.834 2.712 6.527a9.39 9.39 0 002.323.307zM85.265 161.374l-11.49-14.871c-.103.136-.198.28-.298.425l8.403 15.228a9.76 9.76 0 003.385-.782z"
            fill={theme.colors[colorScheme][300]}
          />
          <path
            d="M126.518 169.057a3.128 3.128 0 10-6.245-.35 3.128 3.128 0 006.245.35zM117.277 164.463c-.181 1.64-.357 1.808-1.989 2.092 1.641.181 1.808.357 2.093 1.989.181-1.645.357-1.831 1.989-2.093-1.645-.18-1.831-.357-2.093-1.988z"
            fill={theme.colors.white}
          />
          <path
            d="M138.994 139.512a6.288 6.288 0 10-2.49-12.326 6.288 6.288 0 002.49 12.326z"
            fill={theme.colors.white}
            stroke={theme.colors.white}
            strokeWidth={1.048}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M135.267 129.143a4.78 4.78 0 00-1.605-.571 6.194 6.194 0 011.449-.933c.655.252 1.291.55 1.905.892 2.648 1.494 2.006 1.44 5.457 1.905.318.041.632.112.937.212.197.413.349.846.455 1.291.174.773.201 1.572.078 2.354-1.22-.085-2.86-.303-3.721-.844-1.447-.911-2.063-2.659-4.955-4.306zM143.162 136.545a6.214 6.214 0 01-1.325 1.586c-1.321-.535-2.044-1.261-3.844-1.631-1.573-.323-3.965.073-5.454.392a6.259 6.259 0 01-.93-2.118l-.064-.314a18.081 18.081 0 015.332.006c2.546.367 4.047 1.751 6.285 2.079zM135.616 131.581c-.961.789-2.694.885-4.076.823.104-.681.32-1.34.639-1.951 1.796-.081 4.766.034 3.437 1.128z"
            fill={theme.colors[colorScheme][300]}
          />
          <path
            d="M139.364 127.167c7.159-1.082 13.433-.315 13.965 2.021.623 2.743-6.045 6.598-14.928 8.623-8.883 2.024-16.568 1.442-17.19-1.296-.565-2.478 4.841-5.871 12.437-7.99"
            stroke={theme.colors.white}
            strokeWidth={1.048}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M140.372 127.226c4.471-.372 7.897.471 8.3 2.281.534 2.349-4.211 5.433-10.598 6.89-6.388 1.456-12.007.732-12.542-1.617-.451-1.961 2.793-4.438 7.586-6.047"
            stroke={theme.colors.white}
            strokeWidth={1.048}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M153.599 131.209a1.089 1.089 0 00-.311-.545 1.089 1.089 0 00-.561-.28 1.088 1.088 0 00-.622.079 1.085 1.085 0 00-.44 1.612 1.085 1.085 0 001.507.257c.116-.082.215-.186.29-.307a1.07 1.07 0 00.137-.816zM126.728 134.331a1.08 1.08 0 10-2.108.48 1.08 1.08 0 002.108-.48z"
            fill={theme.colors[colorScheme][300]}
          />
          <path
            d="M86.968 46.53a1.246 1.246 0 11-2.493 0 1.246 1.246 0 012.493 0zM74.78 179.7a1.246 1.246 0 11-2.491 0 1.246 1.246 0 012.492 0zM163.241 95.13a1.245 1.245 0 01-2.471.23 1.249 1.249 0 01.548-1.278 1.246 1.246 0 011.923 1.047zM30.088 104.652a1.246 1.246 0 100-2.493 1.246 1.246 0 000 2.493zM50.508 63.813a1.247 1.247 0 100-2.493 1.247 1.247 0 000 2.493zM101.159 41.425a.624.624 0 11-1.249-.008.624.624 0 011.249.008zM88.972 174.595a.623.623 0 11-1.246-.009.623.623 0 011.246.009zM120.417 62.38a.62.62 0 01-.746.61.623.623 0 11.746-.61zM35.422 77.538a.623.623 0 100-1.247.623.623 0 000 1.247zM56.58 60.54a.624.624 0 11-1.247.008.624.624 0 011.247-.009zM85.28 40.26a.623.623 0 100-1.247.623.623 0 000 1.247zM73.093 173.429a.623.623 0 100-1.247.623.623 0 000 1.247zM101.401 74.595a.623.623 0 100-1.246.623.623 0 000 1.246zM21.625 128.753a.624.624 0 10-.001-1.248.624.624 0 00.001 1.248zM31.996 138.064a.623.623 0 100-1.247.623.623 0 000 1.247zM27.88 141.858a.623.623 0 100-1.246.623.623 0 000 1.246zM70.195 42.583a.623.623 0 100-1.247.623.623 0 000 1.247zM58.007 175.752a.623.623 0 100-1.246.623.623 0 000 1.246zM81.231 72.386a.623.623 0 100-1.247.623.623 0 000 1.247zM90.469 70.396a3.019 3.019 0 10-.965-5.96 3.019 3.019 0 00.965 5.96zM51.33 146.625a3.02 3.02 0 10-.967-5.961 3.02 3.02 0 00.966 5.961zM25.488 93.548a3.019 3.019 0 100-6.038 3.019 3.019 0 000 6.038zM46.239 80.595a1.878 1.878 0 100-3.757 1.878 1.878 0 000 3.757zM117.072 96.418a1.878 1.878 0 100-3.756 1.878 1.878 0 000 3.756zM119.904 46.009c-1.505-.208-1.67-.373-1.878-1.878-.204 1.505-.369 1.67-1.874 1.878 1.505.203 1.67.369 1.874 1.874.208-1.505.373-1.67 1.878-1.874zM107.717 179.178c-1.505-.208-1.671-.373-1.878-1.878-.204 1.505-.369 1.67-1.874 1.878 1.505.204 1.67.369 1.874 1.874.207-1.505.373-1.67 1.878-1.874z"
            fill={theme.colors.white}
          />
          <path
            d="M127.708 26.09a1.558 1.558 0 01.488-2.146l2.54-1.608a1.558 1.558 0 012.155.488v0a1.558 1.558 0 01-.488 2.155l-2.536 1.6a1.567 1.567 0 01-1.739-.046 1.554 1.554 0 01-.42-.443v0z"
            fill={theme.colors.white}
            stroke={theme.colors[colorScheme][900]}
            strokeWidth={0.534}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M126.328 37.066a17.837 17.837 0 00-4.413-4.4 65.123 65.123 0 00-6.971-3.61l-1.447-8.064a27.563 27.563 0 003.709-4.39c1.309-2.11.896-3.527.059-4.987-.838-1.46-1.998-.515-2.173.152a14.906 14.906 0 00-.233 2.128s-.78-5.376-1.232-6.599c-.453-1.223-2.177-.044-2.025.363 0 0-.52-1.527-1.59-1.545-1.071-.018-1.376 1.792-1.376 1.792s-1.375-.637-2.146.16c-.77.798-.403 2.796-.403 2.796s-1.227.448-1.416 2.191c-.188 1.743-.035 4.794.448 5.631.249.398.466.814.65 1.246-.609 7.275-.587 6.796-.766 9.7-.126 2.042 1.214 6.79 3.136 8.767 1.922 1.975 8.799 5.465 8.799 5.465s7.181-1.85 9.39-6.796z"
            fill={theme.colors.white}
          />
          <path
            d="M116.964 43.871s7.168-1.86 9.364-6.805c0 0-.144-.21-.399-.547l-1.864-1.554a62.415 62.415 0 00-7.871 1.17c-3.934.895-6.993-1.022-8.158-5.377-1.165-4.354-2.24-10.801-2.24-10.801-.609 7.275-.587 6.796-.766 9.699-.126 2.043 1.214 6.792 3.136 8.767 1.922 1.976 8.798 5.448 8.798 5.448z"
            fill={theme.colors[colorScheme][400]}
          />
          <path
            opacity={0.5}
            d="M116.964 43.871s7.168-1.86 9.364-6.805c0 0-.144-.21-.399-.547l-1.864-1.554a62.415 62.415 0 00-7.871 1.17c-3.934.895-6.993-1.022-8.158-5.377-1.165-4.354-2.24-10.801-2.24-10.801-.609 7.275-.587 6.796-.766 9.699-.126 2.043 1.214 6.792 3.136 8.767 1.922 1.976 8.798 5.448 8.798 5.448z"
            fill={theme.colors.white}
          />
          <path
            d="M126.328 37.066a17.837 17.837 0 00-4.413-4.4 65.123 65.123 0 00-6.971-3.61l-1.447-8.064a27.563 27.563 0 003.709-4.39c1.309-2.11.896-3.527.059-4.987-.838-1.46-1.998-.515-2.173.152a14.906 14.906 0 00-.233 2.128s-.78-5.376-1.232-6.599c-.453-1.223-2.177-.044-2.025.363 0 0-.52-1.527-1.59-1.545-1.071-.018-1.376 1.792-1.376 1.792s-1.375-.637-2.146.16c-.77.798-.403 2.796-.403 2.796s-1.227.448-1.416 2.191c-.188 1.743-.035 4.794.448 5.631.249.398.466.814.65 1.246-.609 7.275-.587 6.796-.766 9.7-.126 2.042 1.214 6.79 3.136 8.767 1.922 1.975 8.799 5.465 8.799 5.465s7.181-1.85 9.39-6.796z"
            stroke={theme.colors[colorScheme][900]}
            strokeWidth={0.534}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M114.384 25.924l-.896-4.928a27.563 27.563 0 003.709-4.39c1.309-2.11.896-3.526.059-4.986-.838-1.46-1.998-.516-2.173.152a14.906 14.906 0 00-.233 2.128s-.78-5.376-1.232-6.6c-.453-1.222-2.177-.044-2.025.364 0 0-.52-1.528-1.59-1.546-1.071-.018-1.376 1.792-1.376 1.792s-1.375-.636-2.146.161c-.77.798-.403 2.796-.403 2.796s-1.227.448-1.416 2.19c-.188 1.743-.035 4.794.448 5.632.249.398.466.814.65 1.245-.269 3.217-.417 4.928-.511 6.066l9.135-.076zM107.234 37.178c.165.27.346.53.542.78 1.891-1.582 6.147-5.377 8.064-8.633-.538-.17-.896-.27-.896-.27s-3.96 5.193-7.71 8.123z"
            fill={theme.colors.white}
            stroke={theme.colors[colorScheme][900]}
            strokeWidth={0.534}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M114.859 13.886s-4.234-.156-4.682 3.414M111.602 7.65l.143 4.503M108.636 7.915l.291 4.072M106.087 10.871l.457 2.54M112.596 11.942s-4.78.802-6.621 2.365"
            stroke={theme.colors[colorScheme][900]}
            strokeWidth={0.534}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M111.472 40.18c1.559-1.344 1.438-4.032-.278-6.044-1.653-1.935-4.184-2.504-5.761-1.344.533 2.06 1.51 4.372 2.719 5.605a17.554 17.554 0 002.872 2.123c.161-.097.311-.212.448-.34z"
            fill={theme.colors[colorScheme][400]}
          />
          <path
            d="M111.472 40.18c1.559-1.344 1.438-4.032-.278-6.044-1.653-1.935-4.184-2.504-5.761-1.344.533 2.06 1.51 4.372 2.719 5.605a17.554 17.554 0 002.872 2.123c.161-.097.311-.212.448-.34v0z"
            stroke={theme.colors[colorScheme][900]}
            strokeWidth={0.534}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M108.43 45.417s-2.002.21-2.634.752c-.632.542-5.439 4.655-6.218 7.092-.78 2.437 2.181 9.73 5.416 12.544 3.234 2.814 7.275 5.793 10.707 5.179 3.432-.614 7.374-5.9 7.782-7.338.408-1.438-13.019-17.92-13.019-17.92s-.954-.959-2.034-.31z"
            fill={theme.colors.white}
          />
          <path
            d="M108.43 45.417s-.394.04-.896.134l.448.757s-.412 4.247 2.5 9.059c2.912 4.811 8.015 7.867 7.867 9.614-.148 1.747.448 4.081-3.934 3.79-4.381-.291-9.031-7.724-10.635-11.366-.833-1.895-1.55-4.771-2.37-6.998a9.358 9.358 0 00-1.864 2.854c-.78 2.437 2.182 9.73 5.417 12.544 3.234 2.814 7.275 5.793 10.707 5.179 3.431-.614 7.374-5.9 7.782-7.338.407-1.438-13.019-17.92-13.019-17.92s-.923-.959-2.003-.31z"
            fill={theme.colors[colorScheme][400]}
          />
          <path
            opacity={0.5}
            d="M108.43 45.417s-.394.04-.896.134l.448.757s-.412 4.247 2.5 9.059c2.912 4.811 8.015 7.867 7.867 9.614-.148 1.747.448 4.081-3.934 3.79-4.381-.291-9.031-7.724-10.635-11.366-.833-1.895-1.55-4.771-2.37-6.998a9.358 9.358 0 00-1.864 2.854c-.78 2.437 2.182 9.73 5.417 12.544 3.234 2.814 7.275 5.793 10.707 5.179 3.431-.614 7.374-5.9 7.782-7.338.407-1.438-13.019-17.92-13.019-17.92s-.923-.959-2.003-.31z"
            fill={theme.colors.white}
          />
          <path
            d="M108.43 45.417s-2.002.21-2.634.752c-.632.542-5.439 4.655-6.218 7.092-.78 2.437 2.181 9.73 5.416 12.544 3.234 2.814 7.275 5.793 10.707 5.179 3.432-.614 7.374-5.9 7.782-7.338.408-1.438-13.019-17.92-13.019-17.92s-.954-.959-2.034-.31z"
            stroke={theme.colors[colorScheme][900]}
            strokeWidth={0.534}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M125.535 35.646s-2.124-.717-5.287.627c-3.163 1.344-11.074 5.99-12.235 10.035-.766 2.657 7.616 15.062 12.854 17.105 1.406.546 2.688 1.142 5.568-1.205 2.881-2.348 8.92-8.866 10.501-11.738 1.582-2.872-.896-5.013-1.724-6.272-.829-1.259-7.455-9.502-9.677-8.552z"
            fill={theme.colors.white}
          />
          <path
            d="M136.954 50.43l-5.461 1.738s-5.681 6.72-7.719 8.454c-2.038 1.734-8.454-2.478-10.64-4.52l-.645-.6c2.612 3.547 5.86 6.934 8.378 7.92 1.406.546 2.688 1.142 5.568-1.205 2.881-2.348 8.92-8.866 10.501-11.738a.146.146 0 00.018-.05zM134.118 49.83l2.939.38c1.304-2.742-1.026-4.793-1.845-6.02-.82-1.228-7.455-9.494-9.677-8.544a4.952 4.952 0 00-1.25-.184c-2.688 2.025-2.384 4.35.071 8.539 2.456 4.189 9.762 5.829 9.762 5.829z"
            fill={theme.colors[colorScheme][400]}
          />
          <g opacity={0.5} fill={theme.colors.white}>
            <path d="M136.954 50.43l-5.461 1.738s-5.681 6.72-7.719 8.454c-2.038 1.734-8.454-2.478-10.64-4.52l-.645-.6c2.612 3.547 5.86 6.934 8.378 7.92 1.406.546 2.688 1.142 5.568-1.205 2.881-2.348 8.92-8.866 10.501-11.738a.146.146 0 00.018-.05zM134.118 49.83l2.939.38c1.304-2.742-1.026-4.793-1.845-6.02-.82-1.228-7.455-9.494-9.677-8.544a4.952 4.952 0 00-1.25-.184c-2.688 2.025-2.384 4.35.071 8.539 2.456 4.189 9.762 5.829 9.762 5.829z" />
          </g>
          <path
            d="M125.535 35.646s-2.124-.717-5.287.627c-3.163 1.344-11.074 5.99-12.235 10.035-.766 2.657 7.616 15.062 12.854 17.105 1.406.546 2.688 1.142 5.568-1.205 2.881-2.348 8.92-8.866 10.501-11.738 1.582-2.872-.896-5.013-1.724-6.272-.829-1.259-7.455-9.502-9.677-8.552z"
            stroke={theme.colors[colorScheme][900]}
            strokeWidth={0.534}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M127.919 47.93l-5.431-7.45a2.639 2.639 0 00-3.687-.579l-5.734 4.18a2.638 2.638 0 00-.578 3.687l5.431 7.45a2.638 2.638 0 003.686.578l5.735-4.18a2.639 2.639 0 00.578-3.686zM196.825 92.139c-6.698-17.472-23.453-17.28-38.232-17.096-5.094.063-9.906.125-14.336-.448-14.95-1.89-19.224-17.257-19.264-17.472a1.07 1.07 0 00-1.681-.576 1.068 1.068 0 00-.385 1.122c.045.17 4.655 16.953 21.056 19.032 4.583.582 9.695.515 14.641.448 14.784-.184 30.043-.377 36.212 15.72a22.135 22.135 0 011.024 11.631 22.136 22.136 0 01-5.034 10.536c-4.587 5.282-11.097 7.423-17.853 5.873-6.375-1.465-12.673-3.481-18.766-5.43-10.085-3.225-20.51-6.563-31.575-7.49-18.973-1.595-32.171 7.647-47.439 18.341-3.073 2.155-6.25 4.377-9.578 6.59l-1.895 1.263c-9.449 6.308-19.215 12.831-30.267 14.009-8.593.896-17.329-3.109-21.75-10.012a16.914 16.914 0 01-2.375-12.849 14.218 14.218 0 016.742-9.099c5.721-3.409 15.828-4.543 24.448-3.584l.148-2.128c-9.045-.963-19.6.273-25.689 3.898a16.523 16.523 0 00-7.728 10.46 19.038 19.038 0 002.652 14.525c4.436 6.93 12.46 11.119 20.976 11.132.935 0 1.87-.049 2.8-.147 11.572-1.232 22.014-8.203 31.22-14.336l1.891-1.264c3.356-2.24 6.541-4.48 9.624-6.617 14.931-10.461 27.825-19.497 46.036-17.965 10.824.896 21.132 4.207 31.1 7.397 6.138 1.962 12.481 3.992 18.942 5.474 7.553 1.734 14.819-.654 19.945-6.549a24.295 24.295 0 004.39-24.39v0z"
            fill={theme.colors.white}
            stroke={theme.colors[colorScheme][900]}
            strokeWidth={0.534}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M122.403 43.235a1.456 1.456 0 11-2.912.001 1.456 1.456 0 012.912-.001v0zM118.452 46.559a1.453 1.453 0 01-.897 1.349 1.454 1.454 0 01-1.903-1.904 1.451 1.451 0 011.348-.896 1.454 1.454 0 011.452 1.451v0z"
            fill={theme.colors[colorScheme][400]}
            stroke={theme.colors[colorScheme][900]}
            strokeWidth={0.534}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M138.499 46.913c6.297-1.83 9.918-8.416 8.089-14.713-1.83-6.296-8.417-9.917-14.713-8.088-6.297 1.83-9.918 8.416-8.089 14.713 1.83 6.296 8.417 9.917 14.713 8.088z"
            fill={theme.colors.white}
          />
          <path
            d="M144.207 27.792a12.054 12.054 0 00-1.344-1.344 11.857 11.857 0 01-19.093 12.28 11.857 11.857 0 006.774 7.702 11.87 11.87 0 0016.312-8.728 11.87 11.87 0 00-2.649-9.91z"
            fill={theme.colors[colorScheme][400]}
          />
          <path
            opacity={0.5}
            d="M144.207 27.792a12.054 12.054 0 00-1.344-1.344 11.857 11.857 0 01-19.093 12.28 11.857 11.857 0 006.774 7.702 11.87 11.87 0 0016.312-8.728 11.87 11.87 0 00-2.649-9.91z"
            fill={theme.colors.white}
          />
          <path
            d="M138.499 46.913c6.297-1.83 9.918-8.416 8.089-14.713-1.83-6.296-8.417-9.917-14.713-8.088-6.297 1.83-9.918 8.416-8.089 14.713 1.83 6.296 8.417 9.917 14.713 8.088zM145.726 43.714l3.459-2.957"
            stroke={theme.colors[colorScheme][900]}
            strokeWidth={0.534}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M150.103 41.13a.914.914 0 10-1.19-1.39.914.914 0 001.19 1.39z"
            fill={theme.colors[colorScheme][900]}
          />
          <path
            d="M141.488 47.298a1.555 1.555 0 01-.369-1.136 1.56 1.56 0 01.544-1.063l2.276-1.954a1.567 1.567 0 012.204.175v0a1.57 1.57 0 01.371 1.135 1.56 1.56 0 01-.542 1.065l-2.28 1.953a1.563 1.563 0 01-2.204-.175z"
            fill={theme.colors.white}
            stroke={theme.colors[colorScheme][900]}
            strokeWidth={0.534}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M137.774 49.256s-4.61-1.245-6.424 2.218c-1.815 3.463.233 12.096.233 12.096s-3.369 5.474-4.225 6.07c-.856.596-3.266.336-5.64 1.546-2.375 1.21-1.591 2.45-.959 2.867.632.416 2.567-.83 3.136-.784.569.044.506 1.07-1.734 3.396-2.24 2.325-3.266 2.383-2.625 3.458a1.656 1.656 0 001.792.802 1.153 1.153 0 00.627 1.375c.923.448 1.317.103 1.317.103s-.089 1.17.766 1.528a3.643 3.643 0 002.057 0s.811.95 1.63.793c.82-.157 2.688-2.442 4.167-4.386 1.478-1.944 7.168-8.857 9.408-13.095 2.24-4.238 1.178-8.512.721-11.124-.457-2.611-2.527-6.29-4.247-6.863z"
            fill={theme.colors.white}
          />
          <path
            d="M142.021 56.133c-.448-2.612-2.527-6.304-4.247-6.877l-.107-.027a25.234 25.234 0 011.841 11.966c-.583 7.428-7.397 13.288-9.471 15.443-1.662 1.729-3.754 4.153-6.769 5.945a1.453 1.453 0 00.766 1.344 3.641 3.641 0 002.056 0s.811.95 1.631.793c.82-.157 2.688-2.442 4.166-4.386 1.479-1.945 7.168-8.857 9.408-13.095 2.24-4.238 1.183-8.494.726-11.106z"
            fill={theme.colors[colorScheme][400]}
          />
          <path
            opacity={0.5}
            d="M142.021 56.133c-.448-2.612-2.527-6.304-4.247-6.877l-.107-.027a25.234 25.234 0 011.841 11.966c-.583 7.428-7.397 13.288-9.471 15.443-1.662 1.729-3.754 4.153-6.769 5.945a1.453 1.453 0 00.766 1.344 3.641 3.641 0 002.056 0s.811.95 1.631.793c.82-.157 2.688-2.442 4.166-4.386 1.479-1.945 7.168-8.857 9.408-13.095 2.24-4.238 1.183-8.494.726-11.106z"
            fill={theme.colors.white}
          />
          <path
            d="M137.774 49.256s-4.61-1.245-6.424 2.218c-1.815 3.463.233 12.096.233 12.096s-3.369 5.474-4.225 6.07c-.856.596-3.266.336-5.64 1.546-2.375 1.21-1.591 2.45-.959 2.867.632.416 2.567-.83 3.136-.784.569.044.506 1.07-1.734 3.396-2.24 2.325-3.266 2.383-2.625 3.458a1.656 1.656 0 001.792.802 1.153 1.153 0 00.627 1.375c.923.448 1.317.103 1.317.103s-.089 1.17.766 1.528a3.643 3.643 0 002.057 0s.811.95 1.63.793c.82-.157 2.688-2.442 4.167-4.386 1.478-1.944 7.168-8.857 9.408-13.095 2.24-4.238 1.178-8.512.721-11.124-.457-2.611-2.527-6.29-4.247-6.863z"
            stroke={theme.colors[colorScheme][900]}
            strokeWidth={0.534}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M127.721 84.738c.82-.157 2.688-2.442 4.166-4.386.838-1.098 3.024-3.79 5.17-6.689-1.438-4.928-5.694-6.402-7.589-6.81-.856 1.282-1.734 2.51-2.11 2.774-.856.596-3.266.336-5.64 1.545-2.375 1.21-1.591 2.45-.959 2.867.632.417 2.567-.828 3.136-.784.569.045.506 1.071-1.734 3.396s-3.266 2.397-2.625 3.472a1.657 1.657 0 001.792.802 1.153 1.153 0 00.627 1.376c.923.448 1.317.103 1.317.103s-.089 1.169.766 1.527a3.645 3.645 0 002.057 0s.806.963 1.626.807zM121.328 80.925a15.049 15.049 0 004.48-3.548M123.268 82.403a14.72 14.72 0 004.695-3.606M126.09 83.945s2.581-1.931 3.808-3.526"
            stroke={theme.colors[colorScheme][900]}
            strokeWidth={0.534}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M142.227 64.91c.094-.341.166-.682.229-1.018-3.755-2.504-8.485-1.684-11.008-.954.081.39.135.618.135.618l-.39.627c6.03-1.456 9.354-.367 11.034.726z"
            fill={theme.colors.white}
            stroke={theme.colors[colorScheme][900]}
            strokeWidth={0.534}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M139.611 67.198c.333.39.73.72 1.174.977l.515-.896a12.861 12.861 0 001.308-7.293c-.951.041-1.861.4-2.585 1.017a4.408 4.408 0 00-.412 6.195v0z"
            fill={theme.colors[colorScheme][400]}
            stroke={theme.colors[colorScheme][900]}
            strokeWidth={0.534}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M97.163 50.864s1.864 5.376 4.26 5.775c2.397.399 5.73-3.67 6.407-6.72.676-3.05-1.703-5.506-5.143-8.57-3.44-3.064-8.373-4.848-12.544-2.522-4.171 2.325-10.336 8.96-10.336 8.96s-3.857-3.392-5.904-1.64c-2.048 1.752.622 7.11 2.508 9.318 1.887 2.209 5.327 5.448 8.629 4.677 3.302-.77 5.918-6.966 8.064-8.79 2.146-1.823 3.584-1.039 4.059-.488z"
            fill={theme.colors.white}
          />
          <path
            d="M102.512 52.168c-3.642-1.747-2.62-6.12-6.272-7.285-3.651-1.164-3.351 1.313-6.272 5.977-2.921 4.663-8.306 4.368-11.948 3.203a35.8 35.8 0 01-3.4-1.295 15.331 15.331 0 001.791 2.738c1.887 2.208 5.314 5.416 8.611 4.645 3.297-.77 5.918-6.966 8.064-8.79 2.146-1.823 3.611-1.039 4.081-.488 0 0 1.864 5.376 4.261 5.775 2.397.399 5.73-3.67 6.406-6.72.112-.5.141-1.014.085-1.523l-.17-.036s-1.608 5.542-5.237 3.799z"
            fill={theme.colors[colorScheme][400]}
          />
          <path
            opacity={0.5}
            d="M102.512 52.168c-3.642-1.747-2.62-6.12-6.272-7.285-3.651-1.164-3.351 1.313-6.272 5.977-2.921 4.663-8.306 4.368-11.948 3.203a35.8 35.8 0 01-3.4-1.295 15.331 15.331 0 001.791 2.738c1.887 2.208 5.314 5.416 8.611 4.645 3.297-.77 5.918-6.966 8.064-8.79 2.146-1.823 3.611-1.039 4.081-.488 0 0 1.864 5.376 4.261 5.775 2.397.399 5.73-3.67 6.406-6.72.112-.5.141-1.014.085-1.523l-.17-.036s-1.608 5.542-5.237 3.799z"
            fill={theme.colors.white}
          />
          <path
            d="M97.163 50.864s1.864 5.376 4.26 5.775c2.397.399 5.73-3.67 6.407-6.72.676-3.05-1.703-5.506-5.143-8.57-3.44-3.064-8.373-4.848-12.544-2.522-4.171 2.325-10.336 8.96-10.336 8.96s-3.857-3.392-5.904-1.64c-2.048 1.752.622 7.11 2.508 9.318 1.887 2.209 5.327 5.448 8.629 4.677 3.302-.77 5.918-6.966 8.064-8.79 2.146-1.823 3.584-1.039 4.059-.488z"
            stroke={theme.colors[colorScheme][900]}
            strokeWidth={0.534}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M85.412 42.393C82.437 45 79.82 47.818 79.82 47.818s-3.858-3.391-5.905-1.64c-2.047 1.752.623 7.11 2.509 9.319 1.886 2.208 5.313 5.416 8.615 4.645 2.975-.694 5.376-5.824 7.401-8.13a39.78 39.78 0 01-7.03-9.62v0zM95.344 37.832a10.099 10.099 0 00-1.102-.067 31.152 31.152 0 01.735 12.544 2.507 2.507 0 011.097-.045c.247-3.176.43-8.44-.73-12.432z"
            stroke={theme.colors[colorScheme][900]}
            strokeWidth={0.534}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M97.857 44.812a3.938 3.938 0 11-5.098-6.002 3.938 3.938 0 015.098 6.002v0z"
            fill={theme.colors[colorScheme][400]}
            stroke={theme.colors[colorScheme][900]}
            strokeWidth={0.534}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M85.04 60.142a4.928 4.928 0 002.088-1.2c-2.11.35-6.008.233-9.552-4.032-3.45-4.14-3.507-7.36-3.167-9.054a2.18 2.18 0 00-.488.309c-2.052 1.751.622 7.11 2.508 9.318 1.886 2.209 5.31 5.43 8.611 4.66z"
            stroke={theme.colors[colorScheme][900]}
            strokeWidth={0.534}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M107.946 69.904s5.452 1.604 7.168-.107c1.716-1.712 1.971-6.913-1.738-9.117-2.688-1.586-5.47-1.792-9.964-.788-4.493 1.003-8.807 4-9.331 8.731-.525 4.73 1.299 13.628 1.299 13.628s-4.995 1.17-4.762 3.857c.233 2.688 6.15 3.625 9.04 3.37 2.89-.256 7.5-1.179 8.786-4.31 1.285-3.132-2.24-8.862-2.482-11.648-.242-2.787 1.263-3.553 1.984-3.616z"
            fill={theme.colors.white}
          />
          <path
            d="M107.946 69.904s5.452 1.604 7.168-.107c1.12-1.116 1.609-3.7.798-5.981 0 0 .448 2.334-2.769 2.916-3.217.583-8.449-.582-10.779 2.33-2.329 2.912 1.017 8.888 1.308 12.822.292 3.933-.591 5.228-4.525 5.676-3.933.448-7.45-2.374-8.26-.663 1.204 2.074 6.195 2.8 8.78 2.572 2.894-.256 7.5-1.179 8.785-4.31 1.286-3.132-2.24-8.862-2.481-11.648-.242-2.787 1.254-3.544 1.975-3.607z"
            fill={theme.colors[colorScheme][400]}
          />
          <path
            opacity={0.5}
            d="M107.946 69.904s5.452 1.604 7.168-.107c1.12-1.116 1.609-3.7.798-5.981 0 0 .448 2.334-2.769 2.916-3.217.583-8.449-.582-10.779 2.33-2.329 2.912 1.017 8.888 1.308 12.822.292 3.933-.591 5.228-4.525 5.676-3.933.448-7.45-2.374-8.26-.663 1.204 2.074 6.195 2.8 8.78 2.572 2.894-.256 7.5-1.179 8.785-4.31 1.286-3.132-2.24-8.862-2.481-11.648-.242-2.787 1.254-3.544 1.975-3.607z"
            fill={theme.colors.white}
          />
          <path
            d="M107.946 69.904s5.452 1.604 7.168-.107c1.716-1.712 1.971-6.913-1.738-9.117-2.688-1.586-5.47-1.792-9.964-.788-4.493 1.003-8.807 4-9.331 8.731-.525 4.73 1.299 13.628 1.299 13.628s-4.995 1.17-4.762 3.857c.233 2.688 6.15 3.625 9.04 3.37 2.89-.256 7.5-1.179 8.786-4.31 1.285-3.132-2.24-8.862-2.482-11.648-.242-2.787 1.263-3.553 1.984-3.616z"
            stroke={theme.colors[colorScheme][900]}
            strokeWidth={0.534}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M94.224 74.568c.394 3.938 1.165 7.701 1.165 7.701s-4.995 1.17-4.762 3.857c.233 2.688 6.15 3.625 9.04 3.37 2.89-.256 7.5-1.179 8.785-4.31 1.161-2.827-1.585-7.76-2.32-10.752-3.94.643-7.955.689-11.908.134v0zM96.276 63.843a9.757 9.757 0 00-.69.856 31.31 31.31 0 0110.622 6.68 2.49 2.49 0 01.6-.897c-2.423-2.083-6.603-5.29-10.532-6.64z"
            stroke={theme.colors[colorScheme][900]}
            strokeWidth={0.534}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M100.679 69.939a3.943 3.943 0 10-2.366-7.522 3.943 3.943 0 002.366 7.522z"
            fill={theme.colors[colorScheme][400]}
            stroke={theme.colors[colorScheme][900]}
            strokeWidth={0.534}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M108.452 85.168a4.873 4.873 0 00.233-2.397c-.94 1.922-3.297 5.026-8.816 5.439-5.376.403-8.033-1.42-9.207-2.688a2.05 2.05 0 00-.035.578c.237 2.688 6.15 3.624 9.04 3.369 2.89-.256 7.5-1.17 8.785-4.301z"
            stroke={theme.colors[colorScheme][900]}
            strokeWidth={0.534}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M139.19 30.512a41.943 41.943 0 01-3.212-4.893 10.122 10.122 0 108.74 10.869 40.872 40.872 0 01-5.528-5.976v0z"
            fill={theme.colors[colorScheme][900]}
            stroke={theme.colors[colorScheme][900]}
            strokeWidth={0.534}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M140.171 39.7a3.252 3.252 0 11.201-4.44 3.123 3.123 0 01.822 2.262 3.15 3.15 0 01-.294 1.191c-.176.374-.424.71-.729.987zM136.842 32.196a.966.966 0 01-1.605-.799.965.965 0 011.708-.545.965.965 0 01-.103 1.344z"
            fill={theme.colors.white}
          />
          <path
            d="M41.163 109.457l-2.876-.283-.41 4.155 2.877.283.409-4.155z"
            fill={theme.colors[colorScheme][900]}
          />
        </g>
      </g>
      <defs>
        <clipPath id={clipPathId01}>
          <path fill={theme.colors.white} d="M0 0h200v200H0z" />
        </clipPath>
        <clipPath id={clipPathId02}>
          <path
            fill={theme.colors.white}
            transform="translate(-18 -11)"
            d="M0 0h224v224H0z"
          />
        </clipPath>
      </defs>
    </chakra.svg>
  );
};
